import React from "react"
import PropTypes from "prop-types"
import Select from "../UI/Input/Select"
import CheckBox from "../UI/Input/CheckBox"
import { gaFilterClick } from "../../constants/gtm.constants"

const JobFilter = props => {
  const { selectFields, checkboxFields, variant, handleChange } = props || []

  const renderSelectFields = list => {
    return (
      list &&
      Object.entries(list).map(
        key =>
          key[1]?.options?.length > 0 && (
            <Select
              id={key[0]}
              key={key[0]}
              name={key[0]}
              isValid={true}
              onChange={handleChange}
              selectedValue={key[1]?.value}
              showSelect={key[1]?.showSelect}
              selectInput={key[1]?.selectInput}
              getOptionLabel={true}
              options={key[1]?.options}
              variant="CAREER_JOBS_FORM"
              gaEventClass={gaFilterClick}
            />
          )
      )
    )
  }

  return (
    <div>
      {renderSelectFields(selectFields)}
      
      {checkboxFields && (
        
        <CheckBox
          {...checkboxFields?.earlyCareers}
          onChange={handleChange}
          checked={checkboxFields?.earlyCareers?.checked}
          autoFocus={true}
          ariaLabel={checkboxFields?.earlyCareers?.label}
        />
      )}
    </div>
  )
}

JobFilter.propTypes = {
  fieldList: PropTypes.object,
  variant: PropTypes.string,
}

export default JobFilter